import PolicyTypeBadge from "components/PolicyTypeBadge";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { SpaceDetailsPolicy } from "../types";

const SpaceDetailsPoliciesTypeCell = ({
  item: policy,
  ...cellProps
}: TableSimpleCellProps<SpaceDetailsPolicy>) => (
  <TableSimpleCell {...cellProps}>
    <PolicyTypeBadge type={policy.type} />
  </TableSimpleCell>
);

export default SpaceDetailsPoliciesTypeCell;
